var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './StatisticsPage.scss';
import './CustomDatePicker/DatePickerStyles.scss';
import styled from 'styled-components';
import { message, Button, Input, Table, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import CustomTooltip from './CustomTooltip/CustomTooltip';
import SelectStatistics from './Select/Select';
import MyDatePicker from './CustomDatePicker/MyDatePicker';
import { useGetRestaurantsWithSearchQuery } from '@/services/restaurantsApi';
import DashboardCards from './StatisticCard/StatisticCard';
import { useGetStatsRublesTopupsAggregatedQuery, useGetStatsCoinsSpendingAggregatedQuery, useGetStatsRublesTopupsListQuery, useGetStatsCoinsSpendingListQuery, } from '@/services/paymentApi';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAppSelector } from '@/hooks/redux';
import { useGetUserByIdQuery } from '@/services/usersApi';
import { useGetAllNetworksQuery, useGetNetworkMonthlyPaymentsQuery, useGetCityMonthlyPaymentsQuery } from '@/services/restNetworkApi';
import { useGetCitiesQuery } from '@/services/citiesApi';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale('ru');
var ROBOTO_FONT_URLS = [
    '/Roboto-Regular.ttf',
    'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Regular.ttf',
];
var cachedRobotoBase64 = null;
function arrayBufferToBase64(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var i = 0; i < bytes.length; i++)
        binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}
function getRobotoFontBase64() {
    return __awaiter(this, void 0, Promise, function () {
        var lastError, _i, ROBOTO_FONT_URLS_1, url, res, buffer, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (cachedRobotoBase64)
                        return [2 /*return*/, cachedRobotoBase64];
                    lastError = null;
                    _i = 0, ROBOTO_FONT_URLS_1 = ROBOTO_FONT_URLS;
                    _a.label = 1;
                case 1:
                    if (!(_i < ROBOTO_FONT_URLS_1.length))
                        return [3 /*break*/, 7];
                    url = ROBOTO_FONT_URLS_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(url)];
                case 3:
                    res = _a.sent();
                    if (!res.ok)
                        return [3 /*break*/, 6];
                    return [4 /*yield*/, res.arrayBuffer()];
                case 4:
                    buffer = _a.sent();
                    if (buffer.byteLength < 1000)
                        return [3 /*break*/, 6];
                    cachedRobotoBase64 = arrayBufferToBase64(buffer);
                    return [2 /*return*/, cachedRobotoBase64];
                case 5:
                    e_1 = _a.sent();
                    lastError = e_1 instanceof Error ? e_1 : new Error(String(e_1));
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7: throw lastError !== null && lastError !== void 0 ? lastError : new Error('Не удалось загрузить шрифт');
            }
        });
    });
}
function applyCyrillicFont(doc) {
    return getRobotoFontBase64().then(function (base64) {
        doc.addFileToVFS('Roboto-Regular.ttf', base64);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');
    });
}
var dataDay = [
    { name: '00:00', value: 10 },
    { name: '01:00', value: 15 },
    { name: '02:00', value: 20 },
    // ...добавьте данные для каждого часа
];
var dataWeek = [
    { name: 'Пн', value: 100 },
    { name: 'Вт', value: 150 },
    { name: 'Ср', value: 200 },
    // ...добавьте данные для каждого дня недели
];
var dataMonth = [
    { name: '1', value: 300 },
    { name: '2', value: 350 },
    { name: '3', value: 400 },
    // ...добавьте данные для каждого дня месяца
];
var dataYear = [
    { name: 'Янв', value: 500 },
    { name: 'Февр', value: 600 },
    { name: 'Март', value: 700 },
    // ...добавьте данные для каждого месяца
];
var dateFilter = [
    'всё время',
    'год',
    'месяц',
    'неделя',
    'день',
    'промежуток',
];
var mapPeriodToApi = function (label) {
    var m = {
        'всё время': 'all',
        'год': 'год',
        'месяц': 'месяц',
        'неделя': 'неделя',
        'день': 'день',
        'промежуток': 'range',
    };
    return m[label] || 'день';
};
/** Дата в формате YYYY-MM-DD по локальной дате (без сдвига из-за UTC) */
var toLocalDateString = function (d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return "".concat(y, "-").concat(m, "-").concat(day);
};
var StatisticsPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = useState(new Date()), startDate = _p[0], setStartDate = _p[1];
    var _q = useState('день'), selectedFilter = _q[0], setSelectedFilter = _q[1];
    var _r = useState('rubles'), paymentTab = _r[0], setPaymentTab = _r[1];
    var _s = useState(null), selectedRestaurant = _s[0], setSelectedRestaurant = _s[1];
    var _t = useState(null), selectedRestaurantId = _t[0], setSelectedRestaurantId = _t[1];
    var _u = useState(null), selectedNetworkId = _u[0], setSelectedNetworkId = _u[1];
    var _v = useState(null), selectedCityId = _v[0], setSelectedCityId = _v[1];
    var _w = useState(new Date().getMonth() + 1), selectedMonth = _w[0], setSelectedMonth = _w[1];
    var _x = useState(new Date().getFullYear()), selectedYear = _x[0], setSelectedYear = _x[1];
    var _y = useState(function () {
        var d = new Date();
        d.setDate(1);
        return d;
    }), rangeFrom = _y[0], setRangeFrom = _y[1];
    var _z = useState(new Date()), rangeTo = _z[0], setRangeTo = _z[1];
    var _0 = useState(''), topupUserId = _0[0], setTopupUserId = _0[1];
    var _1 = useState('all'), coinsScope = _1[0], setCoinsScope = _1[1];
    var _2 = useState(null), coinsCityId = _2[0], setCoinsCityId = _2[1];
    var _3 = useState(null), coinsNetworkId = _3[0], setCoinsNetworkId = _3[1];
    var _4 = useState(''), coinsUserId = _4[0], setCoinsUserId = _4[1];
    /** Пополнения в рублях: города пользователей; null = все города */
    var _5 = useState(null), rublesCityId = _5[0], setRublesCityId = _5[1];
    /** Контекст ресторана при оплате (body create); null = все */
    var _6 = useState(null), rublesRestaurantId = _6[0], setRublesRestaurantId = _6[1];
    var baseDateStr = toLocalDateString(startDate);
    var rangeFromStr = toLocalDateString(rangeFrom);
    var rangeToStr = toLocalDateString(rangeTo);
    var apiPeriod = useMemo(function () { return mapPeriodToApi(selectedFilter); }, [selectedFilter]);
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var currentUserRole = user === null || user === void 0 ? void 0 : user.role;
    var isClient = currentUserRole === 'сотрудник';
    var _7 = useGetUserByIdQuery({ id: user === null || user === void 0 ? void 0 : user.id }, { skip: !(user === null || user === void 0 ? void 0 : user.id) }), userData = _7.data, isUserDataSuccess = _7.isSuccess;
    var restId = (_a = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _a === void 0 ? void 0 : _a.id;
    var rublesQuery = useMemo(function () {
        var p = { date: baseDateStr, period: apiPeriod };
        if (apiPeriod === 'range') {
            p.dateFrom = rangeFromStr;
            p.dateTo = rangeToStr;
        }
        var uid = topupUserId.trim();
        if (uid)
            p.userId = uid;
        if (rublesCityId != null)
            p.cityId = String(rublesCityId);
        if (rublesRestaurantId != null)
            p.restaurantId = String(rublesRestaurantId);
        return p;
    }, [baseDateStr, apiPeriod, rangeFromStr, rangeToStr, topupUserId, rublesCityId, rublesRestaurantId]);
    var rublesDayQuery = useMemo(function () {
        var p = { date: baseDateStr, period: 'день' };
        var uid = topupUserId.trim();
        if (uid)
            p.userId = uid;
        if (rublesCityId != null)
            p.cityId = String(rublesCityId);
        if (rublesRestaurantId != null)
            p.restaurantId = String(rublesRestaurantId);
        return p;
    }, [baseDateStr, topupUserId, rublesCityId, rublesRestaurantId]);
    var coinsQuery = useMemo(function () {
        var p = { date: baseDateStr, period: apiPeriod };
        if (apiPeriod === 'range') {
            p.dateFrom = rangeFromStr;
            p.dateTo = rangeToStr;
        }
        if (isClient && restId) {
            p.scope = 'restaurant';
            p.scopeId = String(restId);
        }
        else {
            p.scope = coinsScope;
            if (coinsScope === 'restaurant' && selectedRestaurantId != null)
                p.scopeId = String(selectedRestaurantId);
            if (coinsScope === 'city' && coinsCityId != null)
                p.scopeId = String(coinsCityId);
            if (coinsScope === 'network' && coinsNetworkId != null)
                p.scopeId = String(coinsNetworkId);
            if (coinsScope === 'user' && coinsUserId.trim())
                p.scopeId = coinsUserId.trim();
        }
        return p;
    }, [
        baseDateStr,
        apiPeriod,
        rangeFromStr,
        rangeToStr,
        isClient,
        restId,
        coinsScope,
        selectedRestaurantId,
        coinsCityId,
        coinsNetworkId,
        coinsUserId,
    ]);
    var coinsDayQuery = useMemo(function () {
        var p = { date: baseDateStr, period: 'день' };
        if (isClient && restId) {
            p.scope = 'restaurant';
            p.scopeId = String(restId);
        }
        else {
            p.scope = coinsScope;
            if (coinsScope === 'restaurant' && selectedRestaurantId != null)
                p.scopeId = String(selectedRestaurantId);
            if (coinsScope === 'city' && coinsCityId != null)
                p.scopeId = String(coinsCityId);
            if (coinsScope === 'network' && coinsNetworkId != null)
                p.scopeId = String(coinsNetworkId);
            if (coinsScope === 'user' && coinsUserId.trim())
                p.scopeId = coinsUserId.trim();
        }
        return p;
    }, [
        baseDateStr,
        isClient,
        restId,
        coinsScope,
        selectedRestaurantId,
        coinsCityId,
        coinsNetworkId,
        coinsUserId,
    ]);
    var userReady = Boolean(user) && (!isClient || (isUserDataSuccess && restId != null));
    var coinsQueryMissingId = !isClient &&
        ((coinsScope === 'restaurant' && selectedRestaurantId == null) ||
            (coinsScope === 'city' && coinsCityId == null) ||
            (coinsScope === 'network' && coinsNetworkId == null) ||
            (coinsScope === 'user' && !coinsUserId.trim()));
    var _8 = useGetStatsRublesTopupsAggregatedQuery(rublesQuery, { skip: !userReady }), rublesAgg = _8.data, rublesAggLoading = _8.isFetching;
    var rublesDay = useGetStatsRublesTopupsAggregatedQuery(rublesDayQuery, {
        skip: !userReady,
    }).data;
    var _9 = useGetStatsRublesTopupsListQuery(rublesQuery, {
        skip: !userReady,
    }), rublesList = _9.data, rublesListFetching = _9.isFetching;
    var _10 = useGetStatsCoinsSpendingAggregatedQuery(coinsQuery, {
        skip: !userReady || coinsQueryMissingId,
    }), coinsAgg = _10.data, coinsAggLoading = _10.isFetching;
    var coinsDay = useGetStatsCoinsSpendingAggregatedQuery(coinsDayQuery, {
        skip: !userReady || coinsQueryMissingId,
    }).data;
    var _11 = useGetStatsCoinsSpendingListQuery(coinsQuery, {
        skip: !userReady || coinsQueryMissingId,
    }), coinsList = _11.data, coinsListFetching = _11.isFetching;
    var _12 = useState(false), pdfLoading = _12[0], setPdfLoading = _12[1];
    var getPeriodLabel = function () {
        if (selectedFilter === 'день') {
            return "\u0417\u0430 \u0434\u0435\u043D\u044C ".concat(dayjs(startDate).format('DD.MM.YYYY'));
        }
        if (selectedFilter === 'месяц') {
            return "\u0417\u0430 \u043C\u0435\u0441\u044F\u0446 ".concat(dayjs(startDate).format('MMMM YYYY'));
        }
        if (selectedFilter === 'неделя') {
            return "\u041D\u0435\u0434\u0435\u043B\u044F \u043E\u0442 ".concat(dayjs(startDate).format('DD.MM.YYYY'));
        }
        if (selectedFilter === 'год') {
            return "\u0413\u043E\u0434 ".concat(dayjs(startDate).format('YYYY'));
        }
        if (selectedFilter === 'всё время') {
            return 'За всё время';
        }
        if (selectedFilter === 'промежуток') {
            return "\u0421 ".concat(dayjs(rangeFrom).format('DD.MM.YYYY'), " \u043F\u043E ").concat(dayjs(rangeTo).format('DD.MM.YYYY'));
        }
        return "\u041F\u0435\u0440\u0438\u043E\u0434: ".concat(selectedFilter);
    };
    var handleDownloadPdf = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var paymentsList, doc, titleBlock, ctx, tableHead, body, y, suffix, fileName, e_2;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (paymentTab === 'rubles' && !userReady)
                            return [2 /*return*/];
                        if (paymentTab === 'coins' && (!userReady || coinsQueryMissingId)) {
                            message.warning('Укажите сущность для выбранного среза');
                            return [2 /*return*/];
                        }
                        setPdfLoading(true);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, 4, 5]);
                        paymentsList = paymentTab === 'rubles' ? (_a = rublesList === null || rublesList === void 0 ? void 0 : rublesList.items) !== null && _a !== void 0 ? _a : [] : (_b = coinsList === null || coinsList === void 0 ? void 0 : coinsList.items) !== null && _b !== void 0 ? _b : [];
                        doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
                        return [4 /*yield*/, applyCyrillicFont(doc)];
                    case 2:
                        _h.sent();
                        titleBlock = paymentTab === 'rubles'
                            ? 'Отчёт: пополнения (рубли, eGo Coin)'
                            : 'Отчёт: траты eGo Coin в ресторанах';
                        doc.setFontSize(16);
                        doc.text(titleBlock, 14, 15);
                        doc.setFontSize(10);
                        ctx = paymentTab === 'rubles'
                            ? [
                                topupUserId.trim() ? "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C ID: ".concat(topupUserId.trim()) : 'Пользователи: все',
                                rublesCityId == null
                                    ? 'Город: все'
                                    : "\u0413\u043E\u0440\u043E\u0434: ".concat((_d = (_c = cities === null || cities === void 0 ? void 0 : cities.find(function (c) { return c.id === rublesCityId; })) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "ID ".concat(rublesCityId)),
                                rublesRestaurantId == null
                                    ? 'Ресторан (оплата): все'
                                    : "\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D: ".concat((_g = (_f = (_e = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.id === rublesRestaurantId; })) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : "ID ".concat(rublesRestaurantId)),
                            ].join(' · ')
                            : isClient
                                ? "\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D (\u0432\u0430\u0448): ".concat(restaurantNameForReport)
                                : "\u0421\u0440\u0435\u0437: ".concat(coinsScope).concat(coinsScope === 'restaurant' && selectedRestaurantId
                                    ? " #".concat(selectedRestaurantId)
                                    : '').concat(coinsScope === 'city' && coinsCityId ? " #".concat(coinsCityId) : '').concat(coinsScope === 'network' && coinsNetworkId ? " #".concat(coinsNetworkId) : '').concat(coinsScope === 'user' && coinsUserId.trim() ? " user ".concat(coinsUserId.trim()) : '');
                        doc.text(ctx, 14, 21);
                        doc.text(getPeriodLabel(), 14, 27);
                        tableHead = paymentTab === 'rubles'
                            ? [['Дата', 'Сумма ₽', 'Город (оплата)', 'Ресторан (оплата)', 'Пользователь', 'Описание']]
                            : [
                                [
                                    'Дата',
                                    'Сумма (коины)',
                                    'Пользователь',
                                    'Описание',
                                    'Ресторан',
                                    'Город',
                                    'Сеть',
                                ],
                            ];
                        body = paymentTab === 'rubles'
                            ? paymentsList.map(function (p) {
                                var _a, _b;
                                return [
                                    dayjs(p.createdAt).format('DD.MM.YYYY HH:mm'),
                                    String((_a = p.amount) !== null && _a !== void 0 ? _a : ''),
                                    p.topupCityId != null && p.topupCityId !== undefined
                                        ? String(p.topupCityId)
                                        : '—',
                                    p.topupRestaurantId != null && p.topupRestaurantId !== undefined
                                        ? String(p.topupRestaurantId)
                                        : '—',
                                    p.userName || p.userId || '—',
                                    (_b = p.description) !== null && _b !== void 0 ? _b : '—',
                                ];
                            })
                            : paymentsList.map(function (p) {
                                var _a, _b, _c, _d, _e, _f;
                                return [
                                    dayjs(p.createdAt).format('DD.MM.YYYY HH:mm'),
                                    String((_a = p.amount) !== null && _a !== void 0 ? _a : ''),
                                    p.userName || p.userId || '—',
                                    (_b = p.description) !== null && _b !== void 0 ? _b : '—',
                                    (_d = (_c = p.restaurant) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '—',
                                    (_e = p.cityName) !== null && _e !== void 0 ? _e : '—',
                                    (_f = p.networkName) !== null && _f !== void 0 ? _f : '—',
                                ];
                            });
                        y = 33;
                        if (paymentsList.length > 0) {
                            doc.autoTable({
                                startY: y,
                                head: tableHead,
                                body: body,
                                margin: { left: 14 },
                                styles: { fontSize: 7, font: 'Roboto' },
                                headStyles: {
                                    fillColor: paymentTab === 'rubles' ? [82, 196, 26] : [255, 152, 0],
                                    font: 'Roboto',
                                },
                            });
                        }
                        else {
                            doc.setFontSize(10);
                            doc.text('Нет данных за выбранный период', 14, y);
                        }
                        suffix = paymentTab === 'rubles' ? 'rubles-topups' : 'coins-spend';
                        fileName = "otchet_".concat(suffix, "_").concat(dayjs(startDate).format('YYYY-MM-DD'), "_").concat(selectedFilter, ".pdf");
                        doc.save(fileName);
                        message.success('PDF сохранён');
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _h.sent();
                        console.error(e_2);
                        message.error('Не удалось создать отчёт. Проверьте подключение к интернету для загрузки шрифта.');
                        return [3 /*break*/, 5];
                    case 4:
                        setPdfLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var isSuperAdmin = currentUserRole === 'системный администратор';
    var isManager = currentUserRole === 'системный менеджер';
    var isEmployee = currentUserRole === 'сотрудник';
    // Get networks (only for super admin and manager)
    var _13 = useGetAllNetworksQuery(undefined, {
        skip: !isSuperAdmin && !isManager,
    }), networks = _13.data, isNetworksLoading = _13.isLoading;
    // Города: для фильтра «Рубли» (и блоков ниже) у всех, кроме сотрудника
    var _14 = useGetCitiesQuery(undefined, {
        skip: !user || isClient,
    }), cities = _14.data, isCitiesLoading = _14.isLoading;
    // Get network monthly payments
    var _15 = useGetNetworkMonthlyPaymentsQuery({ id: selectedNetworkId, year: selectedYear, month: selectedMonth }, { skip: !selectedNetworkId }), networkPayments = _15.data, isNetworkPaymentsLoading = _15.isLoading;
    // Get city monthly payments
    var _16 = useGetCityMonthlyPaymentsQuery({ cityId: selectedCityId, year: selectedYear, month: selectedMonth }, { skip: !selectedCityId }), cityPayments = _16.data, isCityPaymentsLoading = _16.isLoading;
    var queryParams = isSuperAdmin
        ? {
            page: 1,
            limit: 10000,
            search: '',
        }
        : isManager
            ? {
                page: 1,
                limit: 100000,
                search: '',
                ownerId: user === null || user === void 0 ? void 0 : user.id,
            }
            : isEmployee
                ? {
                    page: 1,
                    limit: 100000,
                    search: '',
                    userRestId: restId,
                }
                : {
                    page: 1,
                    limit: 100000,
                    search: '',
                };
    var _17 = useGetRestaurantsWithSearchQuery(queryParams, {
        skip: !user,
    }), allRestaurantsData = _17.data, isRestaurantsLoading = _17.isLoading;
    var restaurantsData = allRestaurantsData;
    var restaurantIdForReport = isClient ? restId : selectedRestaurantId;
    var restaurantNameForReport = (_e = (_d = (_c = (_b = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _b === void 0 ? void 0 : _b.find(function (r) { return r.id === restaurantIdForReport; })) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : selectedRestaurant) !== null && _e !== void 0 ? _e : '—';
    useEffect(function () {
        var _a, _b, _c;
        if (restaurantsData && ((_a = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var restaurant = (_b = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _b === void 0 ? void 0 : _b.find(function (r) { return r.name === selectedRestaurant; });
            if (restaurant) {
                setSelectedRestaurantId(restaurant.id);
            }
            else {
                setSelectedRestaurantId((_c = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data[0]) === null || _c === void 0 ? void 0 : _c.id);
            }
        }
    }, [restaurantsData, selectedRestaurant]);
    // Download network monthly payments as CSV
    var downloadNetworkPayments = function () {
        var _a, _b;
        if (!networkPayments)
            return;
        var csvContent = [
            ['Сеть', 'Месяц', 'Год', 'Общая сумма (₽)', 'Кэш (₽)', 'Монеты (₽)', 'Количество платежей'].join(','),
            [
                ((_a = networks === null || networks === void 0 ? void 0 : networks.find(function (n) { return n.id === selectedNetworkId; })) === null || _a === void 0 ? void 0 : _a.name) || '',
                selectedMonth,
                selectedYear,
                networkPayments.total || 0,
                networkPayments.totalCash || 0,
                networkPayments.totalCoins || 0,
                ((_b = networkPayments.payments) === null || _b === void 0 ? void 0 : _b.length) || 0
            ].join(',')
        ].join('\n');
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', "network_payments_".concat(selectedNetworkId, "_").concat(selectedYear, "_").concat(selectedMonth, ".csv"));
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // Download city monthly payments - total
    var downloadCityPaymentsTotal = function () {
        var _a, _b;
        if (!cityPayments)
            return;
        var cityName = cityPayments.cityName || ((_a = cities === null || cities === void 0 ? void 0 : cities.find(function (c) { return c.id === selectedCityId; })) === null || _a === void 0 ? void 0 : _a.name) || 'Unknown';
        var csvContent = [
            ['Город', 'Месяц', 'Год', 'Общая сумма (₽)', 'Кэш (₽)', 'Монеты (₽)', 'Количество платежей'].join(','),
            [
                cityName,
                selectedMonth,
                selectedYear,
                cityPayments.total || 0,
                cityPayments.totalCash || 0,
                cityPayments.totalCoins || 0,
                ((_b = cityPayments.payments) === null || _b === void 0 ? void 0 : _b.length) || 0
            ].join(',')
        ].join('\n');
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', "city_payments_total_".concat(cityName, "_").concat(selectedYear, "_").concat(selectedMonth, ".csv"));
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // Download city monthly payments - coins only
    var downloadCityPaymentsCoins = function () {
        var _a, _b;
        if (!cityPayments)
            return;
        var cityName = cityPayments.cityName || ((_a = cities === null || cities === void 0 ? void 0 : cities.find(function (c) { return c.id === selectedCityId; })) === null || _a === void 0 ? void 0 : _a.name) || 'Unknown';
        var coinPayments = ((_b = cityPayments.payments) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.paymentMethod === 'coins'; })) || [];
        var csvContent = __spreadArray([
            ['ID', 'Сумма (₽)', 'Метод оплаты', 'Ресторан ID', 'Название ресторана', 'Дата создания'].join(',')
        ], coinPayments.map(function (p) {
            return [
                p.id,
                p.amount || 0,
                p.paymentMethod || 'coins',
                p.restaurantId || '',
                p.restaurantName || '',
                p.createdAt || ''
            ].join(',');
        }), true).join('\n');
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', "city_payments_coins_".concat(cityName, "_").concat(selectedYear, "_").concat(selectedMonth, ".csv"));
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (_jsxs("div", __assign({ className: 'StatisticsPage' }, { children: [_jsx(PageHeader, { children: _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '24px' } }, { children: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430" })) }), _jsxs("div", __assign({ style: { padding: '40px', fontFamily: 'Montserrat Regular' } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'row', gap: '32px', alignItems: 'center', flexWrap: 'wrap' } }, { children: [!isClient && paymentTab === 'rubles' && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column', gap: 4 } }, { children: [_jsx("span", __assign({ style: { fontSize: 12, color: '#666' } }, { children: "\u0413\u043E\u0440\u043E\u0434 (\u043C\u0435\u0442\u043A\u0430 / \u043F\u0440\u043E\u0444\u0438\u043B\u044C)" })), _jsx(Select, { showSearch: true, allowClear: true, placeholder: "\u0412\u0441\u0435 \u0433\u043E\u0440\u043E\u0434\u0430", value: rublesCityId !== null && rublesCityId !== void 0 ? rublesCityId : undefined, onChange: function (v) { return setRublesCityId(v == null ? null : Number(v)); }, loading: isCitiesLoading, disabled: isCitiesLoading, options: cities === null || cities === void 0 ? void 0 : cities.map(function (c) { return ({ value: c.id, label: c.name }); }), optionFilterProp: "label", filterOption: function (input, option) {
                                                    var _a;
                                                    return String((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '')
                                                        .toLowerCase()
                                                        .includes(String(input).toLowerCase().trim());
                                                }, style: {
                                                    minWidth: 220,
                                                    maxWidth: 360,
                                                    fontFamily: 'Montserrat Regular',
                                                } })] })), _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column', gap: 4 } }, { children: [_jsx("span", __assign({ style: { fontSize: 12, color: '#666' } }, { children: "\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D (\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442 \u043E\u043F\u043B\u0430\u0442\u044B)" })), _jsx(Select, { showSearch: true, allowClear: true, placeholder: "\u0412\u0441\u0435 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u044B", value: rublesRestaurantId !== null && rublesRestaurantId !== void 0 ? rublesRestaurantId : undefined, onChange: function (v) { return setRublesRestaurantId(v == null ? null : Number(v)); }, loading: isRestaurantsLoading, disabled: isRestaurantsLoading, options: (_f = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data) === null || _f === void 0 ? void 0 : _f.map(function (r) {
                                                    return ({
                                                        value: r.id,
                                                        label: r.name,
                                                    });
                                                }), optionFilterProp: "label", filterOption: function (input, option) {
                                                    var _a;
                                                    return String((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '')
                                                        .toLowerCase()
                                                        .includes(String(input).toLowerCase().trim());
                                                }, style: {
                                                    minWidth: 220,
                                                    maxWidth: 360,
                                                    fontFamily: 'Montserrat Regular',
                                                } })] }))] })), !isClient && paymentTab === 'coins' && (_jsx(SelectStatistics, { isLoading: isRestaurantsLoading, data: restaurantsData ? restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.data.map(function (item) { return item.name; }) : [], setItem: setSelectedRestaurant })), _jsx(MyDatePicker, { startDate: startDate, setStartDate: setStartDate }), _jsx(SelectStatistics, { setItem: setSelectedFilter, data: dateFilter }), _jsxs("div", __assign({ style: { display: 'flex', gap: '0', border: '1px solid #d9d9d9', borderRadius: '8px', overflow: 'hidden' } }, { children: [_jsx("button", __assign({ type: "button", onClick: function () { return setPaymentTab('rubles'); }, style: {
                                            padding: '8px 20px',
                                            border: 'none',
                                            background: paymentTab === 'rubles' ? '#8884d8' : '#fff',
                                            color: paymentTab === 'rubles' ? '#fff' : '#333',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                        } }, { children: "\u0420\u0443\u0431\u043B\u0438" })), _jsx("button", __assign({ type: "button", onClick: function () { return setPaymentTab('coins'); }, style: {
                                            padding: '8px 20px',
                                            border: 'none',
                                            borderLeft: '1px solid #d9d9d9',
                                            background: paymentTab === 'coins' ? '#FF9800' : '#fff',
                                            color: paymentTab === 'coins' ? '#fff' : '#333',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                        } }, { children: "\u041A\u043E\u0438\u043D\u044B" }))] })), _jsx(Button, __assign({ type: "primary", icon: _jsx(DownloadOutlined, {}), onClick: handleDownloadPdf, loading: pdfLoading, disabled: paymentTab === 'coins' && (coinsQueryMissingId || (isClient && !restId)), style: { marginLeft: 'auto' } }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043E\u0442\u0447\u0451\u0442 (PDF)" }))] })), _jsxs("div", __assign({ style: {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '16px',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            marginTop: '20px',
                        } }, { children: [selectedFilter === 'промежуток' && (_jsxs(_Fragment, { children: [_jsx("span", { children: "\u0421" }), _jsx(DatePicker, { selected: rangeFrom, onChange: function (d) { return d && setRangeFrom(d); }, dateFormat: "dd.MM.yyyy", className: "date-picker-input" }), _jsx("span", { children: "\u043F\u043E" }), _jsx(DatePicker, { selected: rangeTo, onChange: function (d) { return d && setRangeTo(d); }, dateFormat: "dd.MM.yyyy", className: "date-picker-input" })] })), paymentTab === 'rubles' && (_jsx(Input, { allowClear: true, placeholder: "ID \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F (\u0432\u0441\u0435, \u0435\u0441\u043B\u0438 \u043F\u0443\u0441\u0442\u043E)", value: topupUserId, onChange: function (e) { return setTopupUserId(e.target.value); }, style: { maxWidth: 280 } })), paymentTab === 'coins' && isClient && (_jsx("span", __assign({ style: { color: '#666', fontSize: 14 } }, { children: "\u041A\u043E\u0438\u043D\u044B: \u0442\u0440\u0430\u0442\u044B \u0432 \u0432\u0430\u0448\u0435\u043C \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0435" }))), paymentTab === 'coins' && !isClient && (_jsxs(_Fragment, { children: [_jsx("span", { children: "\u0421\u0440\u0435\u0437:" }), _jsxs("select", __assign({ value: coinsScope, onChange: function (e) {
                                            return setCoinsScope(e.target.value);
                                        }, style: {
                                            padding: '8px 12px',
                                            borderRadius: 8,
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            minWidth: 200,
                                        } }, { children: [_jsx("option", __assign({ value: "all" }, { children: "\u0412\u0441\u0435 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u044B" })), _jsx("option", __assign({ value: "restaurant" }, { children: "\u041A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0439 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D" })), _jsx("option", __assign({ value: "city" }, { children: "\u0413\u043E\u0440\u043E\u0434" })), _jsx("option", __assign({ value: "network" }, { children: "\u0421\u0435\u0442\u044C" })), _jsx("option", __assign({ value: "user" }, { children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C (ID)" }))] })), coinsScope === 'city' && (_jsxs("select", __assign({ value: coinsCityId || '', onChange: function (e) { return setCoinsCityId(e.target.value ? Number(e.target.value) : null); }, style: { padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', minWidth: 200 } }, { children: [_jsx("option", __assign({ value: "" }, { children: "\u0413\u043E\u0440\u043E\u0434" })), cities === null || cities === void 0 ? void 0 : cities.map(function (c) { return (_jsx("option", __assign({ value: c.id }, { children: c.name }), c.id)); })] }))), coinsScope === 'network' && (_jsxs("select", __assign({ value: coinsNetworkId || '', onChange: function (e) { return setCoinsNetworkId(e.target.value ? Number(e.target.value) : null); }, style: { padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', minWidth: 200 } }, { children: [_jsx("option", __assign({ value: "" }, { children: "\u0421\u0435\u0442\u044C" })), networks === null || networks === void 0 ? void 0 : networks.map(function (n) { return (_jsx("option", __assign({ value: n.id }, { children: n.name }), n.id)); })] }))), coinsScope === 'user' && (_jsx(Input, { placeholder: "ID \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", value: coinsUserId, onChange: function (e) { return setCoinsUserId(e.target.value); }, style: { maxWidth: 200 } }))] })), paymentTab === 'coins' && !isClient && coinsQueryMissingId && (_jsx("span", __assign({ style: { color: '#d46b08' } }, { children: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0443\u0449\u043D\u043E\u0441\u0442\u044C \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0437\u0430" })))] })), paymentTab === 'rubles' && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ style: { marginBottom: '40px', marginTop: '24px' } }, { children: _jsx(DashboardCards, { total: rublesAgg === null || rublesAgg === void 0 ? void 0 : rublesAgg.total, totalClients: rublesAgg === null || rublesAgg === void 0 ? void 0 : rublesAgg.count, todaysTotal: rublesDay === null || rublesDay === void 0 ? void 0 : rublesDay.total, summary: rublesAgg === null || rublesAgg === void 0 ? void 0 : rublesAgg.total, labels: {
                                        count: 'Количество пополнений',
                                        period: 'Сумма за период',
                                        daySlice: 'Сумма за сутки (дата в календаре)',
                                        total: 'Итого за период',
                                    } }) })), _jsx("div", { style: { height: '20px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u2014 \u0433\u0440\u0430\u0444\u0438\u043A" })), _jsx("div", { style: { height: '20px' } }), _jsx(ResponsiveContainer, __assign({ width: "100%", style: { background: '#fff', padding: '32px', borderRadius: '8px' }, height: 400 }, { children: _jsxs(LineChart, __assign({ data: (_g = rublesAgg === null || rublesAgg === void 0 ? void 0 : rublesAgg.data) !== null && _g !== void 0 ? _g : [] }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "name" }), _jsx(YAxis, {}), _jsx(Tooltip, { content: CustomTooltip }), _jsx(Line, { type: "linear", dataKey: "value", stroke: "#8884d8", activeDot: { r: 8 }, isAnimationActive: !rublesAggLoading })] })) })), _jsx("div", { style: { height: '24px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439" })), _jsx("div", { style: { height: '12px' } }), _jsx(Table, { size: "small", rowKey: "id", loading: rublesAggLoading || rublesListFetching, dataSource: (_h = rublesList === null || rublesList === void 0 ? void 0 : rublesList.items) !== null && _h !== void 0 ? _h : [], pagination: { pageSize: 15 }, columns: [
                                    {
                                        title: 'Дата',
                                        dataIndex: 'createdAt',
                                        width: 160,
                                        render: function (v) { return dayjs(v).format('DD.MM.YYYY HH:mm'); },
                                    },
                                    { title: 'Сумма, ₽', dataIndex: 'amount', width: 110 },
                                    {
                                        title: 'Город (оплата)',
                                        dataIndex: 'topupCityId',
                                        width: 110,
                                        render: function (v) {
                                            return v != null && v !== undefined ? v : '—';
                                        },
                                    },
                                    {
                                        title: 'Ресторан (оплата)',
                                        dataIndex: 'topupRestaurantId',
                                        width: 120,
                                        render: function (v) {
                                            return v != null && v !== undefined ? v : '—';
                                        },
                                    },
                                    { title: 'ID', dataIndex: 'userId', width: 90 },
                                    { title: 'Имя', dataIndex: 'userName', width: 180 },
                                    { title: 'Описание', dataIndex: 'description' },
                                ] })] })), paymentTab === 'coins' && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ style: { marginBottom: '40px', marginTop: '24px' } }, { children: _jsx(DashboardCards, { total: coinsAgg === null || coinsAgg === void 0 ? void 0 : coinsAgg.total, totalClients: coinsAgg === null || coinsAgg === void 0 ? void 0 : coinsAgg.count, todaysTotal: coinsDay === null || coinsDay === void 0 ? void 0 : coinsDay.total, summary: coinsAgg === null || coinsAgg === void 0 ? void 0 : coinsAgg.total, variant: "coins", labels: {
                                        count: 'Количество трат',
                                        period: 'Сумма за период (коины)',
                                        daySlice: 'Сумма за сутки (календарь)',
                                        total: 'Итого за период',
                                    } }) })), _jsx("div", { style: { height: '20px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u0422\u0440\u0430\u0442\u044B eGo Coin \u0432 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0430\u0445 \u2014 \u0433\u0440\u0430\u0444\u0438\u043A" })), _jsx("div", { style: { height: '20px' } }), _jsx(ResponsiveContainer, __assign({ width: "100%", style: { background: '#fff', padding: '32px', borderRadius: '8px' }, height: 400 }, { children: _jsxs(LineChart, __assign({ data: (_j = coinsAgg === null || coinsAgg === void 0 ? void 0 : coinsAgg.data) !== null && _j !== void 0 ? _j : [] }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "name" }), _jsx(YAxis, {}), _jsx(Tooltip, { content: CustomTooltip }), _jsx(Line, { type: "linear", dataKey: "value", stroke: "#FF9800", activeDot: { r: 8 }, isAnimationActive: !coinsAggLoading })] })) })), _jsx("div", { style: { height: '24px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0440\u0430\u0442" })), _jsx("div", { style: { height: '12px' } }), _jsx(Table, { size: "small", rowKey: "id", loading: coinsAggLoading || coinsListFetching, dataSource: (_k = coinsList === null || coinsList === void 0 ? void 0 : coinsList.items) !== null && _k !== void 0 ? _k : [], pagination: { pageSize: 15 }, columns: [
                                    {
                                        title: 'Дата',
                                        dataIndex: 'createdAt',
                                        width: 150,
                                        render: function (v) { return dayjs(v).format('DD.MM.YYYY HH:mm'); },
                                    },
                                    { title: 'Сумма', dataIndex: 'amount', width: 100 },
                                    { title: 'ID', dataIndex: 'userId', width: 80 },
                                    { title: 'Имя', dataIndex: 'userName', width: 160 },
                                    { title: 'Описание', dataIndex: 'description', width: 200 },
                                    {
                                        title: 'Ресторан',
                                        width: 160,
                                        render: function (_, row) { var _a, _b; return (_b = (_a = row.restaurant) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '—'; },
                                    },
                                    { title: 'Город', dataIndex: 'cityName', width: 120 },
                                    { title: 'Сеть', dataIndex: 'networkName', width: 140 },
                                ] })] })), (isSuperAdmin || isManager) && (_jsxs(_Fragment, { children: [_jsx("div", { style: { height: '40px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0441\u0435\u0442\u044F\u043C \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u043E\u0432" })), _jsx("div", { style: { height: '20px' } }), _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'row', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' } }, { children: [_jsxs("select", __assign({ value: selectedNetworkId || '', onChange: function (e) { return setSelectedNetworkId(e.target.value ? Number(e.target.value) : null); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            minWidth: '200px'
                                        } }, { children: [_jsx("option", __assign({ value: "" }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0442\u044C" })), networks === null || networks === void 0 ? void 0 : networks.map(function (network) { return (_jsx("option", __assign({ value: network.id }, { children: network.name }), network.id)); })] })), _jsx("select", __assign({ value: selectedMonth, onChange: function (e) { return setSelectedMonth(Number(e.target.value)); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px'
                                        } }, { children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (month) { return (_jsx("option", __assign({ value: month }, { children: new Date(2000, month - 1).toLocaleString('ru', { month: 'long' }) }), month)); }) })), _jsx("input", { type: "number", value: selectedYear, onChange: function (e) { return setSelectedYear(Number(e.target.value)); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            width: '100px'
                                        }, min: "2020", max: "2100" }), selectedNetworkId && networkPayments && (_jsx("button", __assign({ onClick: downloadNetworkPayments, style: {
                                            padding: '8px 24px',
                                            borderRadius: '8px',
                                            border: 'none',
                                            background: '#4CAF50',
                                            color: 'white',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                            fontWeight: 500
                                        } }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043E\u0442\u0447\u0435\u0442" })))] })), selectedNetworkId && networkPayments && (_jsx("div", __assign({ style: { background: '#fff', padding: '24px', borderRadius: '8px', marginBottom: '20px' } }, { children: _jsxs("div", __assign({ style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' } }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041E\u0431\u0449\u0430\u044F \u0441\u0443\u043C\u043C\u0430" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#333' } }, { children: ["\u20BD ", networkPayments.total || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041A\u044D\u0448" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#4CAF50' } }, { children: ["\u20BD ", networkPayments.totalCash || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041C\u043E\u043D\u0435\u0442\u044B" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#FF9800' } }, { children: ["\u20BD ", networkPayments.totalCoins || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439" })), _jsx("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#333' } }, { children: ((_l = networkPayments.payments) === null || _l === void 0 ? void 0 : _l.length) || 0 }))] })] })) }))), selectedNetworkId && isNetworkPaymentsLoading && (_jsx("div", __assign({ style: { padding: '20px', textAlign: 'center' } }, { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." })))] })), (isSuperAdmin || isManager) && (_jsxs(_Fragment, { children: [_jsx("div", { style: { height: '40px' } }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 500, fontSize: '20px' } }, { children: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u0433\u043E\u0440\u043E\u0434\u0430\u043C" })), _jsx("div", { style: { height: '20px' } }), _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'row', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' } }, { children: [_jsxs("select", __assign({ value: selectedCityId || '', onChange: function (e) { return setSelectedCityId(e.target.value ? Number(e.target.value) : null); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            minWidth: '200px'
                                        } }, { children: [_jsx("option", __assign({ value: "" }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434" })), cities === null || cities === void 0 ? void 0 : cities.map(function (city) { return (_jsx("option", __assign({ value: city.id }, { children: city.name }), city.id)); })] })), _jsx("select", __assign({ value: selectedMonth, onChange: function (e) { return setSelectedMonth(Number(e.target.value)); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px'
                                        } }, { children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (month) { return (_jsx("option", __assign({ value: month }, { children: new Date(2000, month - 1).toLocaleString('ru', { month: 'long' }) }), month)); }) })), _jsx("input", { type: "number", value: selectedYear, onChange: function (e) { return setSelectedYear(Number(e.target.value)); }, style: {
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                            fontFamily: 'Montserrat Regular',
                                            fontSize: '14px',
                                            width: '100px'
                                        }, min: "2020", max: "2100" }), selectedCityId && cityPayments && (_jsxs(_Fragment, { children: [_jsx("button", __assign({ onClick: downloadCityPaymentsTotal, style: {
                                                    padding: '8px 24px',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    background: '#4CAF50',
                                                    color: 'white',
                                                    fontFamily: 'Montserrat Regular',
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    fontWeight: 500
                                                } }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u043E\u0442\u0447\u0435\u0442" })), _jsx("button", __assign({ onClick: downloadCityPaymentsCoins, style: {
                                                    padding: '8px 24px',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    background: '#FF9800',
                                                    color: 'white',
                                                    fontFamily: 'Montserrat Regular',
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    fontWeight: 500
                                                } }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043C\u043E\u043D\u0435\u0442\u044B" }))] }))] })), selectedCityId && cityPayments && (_jsx("div", __assign({ style: { background: '#fff', padding: '24px', borderRadius: '8px', marginBottom: '20px' } }, { children: _jsxs("div", __assign({ style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' } }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u0413\u043E\u0440\u043E\u0434" })), _jsx("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#333' } }, { children: cityPayments.cityName || ((_m = cities === null || cities === void 0 ? void 0 : cities.find(function (c) { return c.id === selectedCityId; })) === null || _m === void 0 ? void 0 : _m.name) || 'Unknown' }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041E\u0431\u0449\u0430\u044F \u0441\u0443\u043C\u043C\u0430" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#333' } }, { children: ["\u20BD ", cityPayments.total || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041A\u044D\u0448" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#4CAF50' } }, { children: ["\u20BD ", cityPayments.totalCash || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041C\u043E\u043D\u0435\u0442\u044B" })), _jsxs("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#FF9800' } }, { children: ["\u20BD ", cityPayments.totalCoins || 0] }))] }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontSize: '14px', color: '#666', marginBottom: '8px' } }, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439" })), _jsx("div", __assign({ style: { fontSize: '24px', fontWeight: 600, color: '#333' } }, { children: ((_o = cityPayments.payments) === null || _o === void 0 ? void 0 : _o.length) || 0 }))] })] })) }))), selectedCityId && isCityPaymentsLoading && (_jsx("div", __assign({ style: { padding: '20px', textAlign: 'center' } }, { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." })))] }))] }))] })));
};
var PageHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"], ["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"])));
export default StatisticsPage;
var templateObject_1;
